import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ShieldCheck } from 'lucide-react';
export function PricingCTA() {
  return <section id="pricing" className="w-full bg-[#FDF8F0] px-4 py-16 md:py-24" data-id="element-132">
      <div className="max-w-3xl mx-auto" data-id="element-133">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-white rounded-3xl shadow-xl overflow-hidden border border-[#E2E8F0]" data-id="element-134">
          <div className="bg-[#1B2A4A] p-4 text-center" data-id="element-135">
            <p className="text-[#FDF8F0] font-medium tracking-wide text-sm uppercase" data-id="element-136">
              Oferta Especial
            </p>
          </div>

          <div className="p-8 md:p-12 text-center" data-id="element-137">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1B2A4A] mb-2 font-serif" data-id="element-138">
              Reset Familiar 7 Días
            </h2>
            <p className="text-[#4A5568] mb-8" data-id="element-139">Guía Digital (PDF)</p>

            <div className="flex flex-col items-center justify-center mb-8" data-id="element-140">
              <div className="flex items-center gap-3 mb-2" data-id="element-141">
                <span className="text-2xl text-[#4A5568] line-through font-serif" data-id="element-142">
                  $19.398,78
                </span>
                <span className="inline-flex items-center px-3 py-1 bg-[#2D6A4F] text-white text-sm font-bold rounded-full tracking-wide" data-id="element-143">
                  50% OFF
                </span>
              </div>
              <div className="flex items-baseline" data-id="element-144">
                <span className="text-6xl font-bold text-[#2D6A4F] font-serif" data-id="element-145">
                  $9.699,39
                </span>
                <span className="text-[#4A5568] ml-2 text-xl" data-id="element-146">ARS</span>
              </div>
            </div>

            <div className="bg-[#F5EDE3] p-4 rounded-lg mb-8 inline-block" data-id="element-147">
              <p className="text-[#C4704B] font-medium italic" data-id="element-148">
                "Lo que cuesta un antojo… por un sistema que te puede devolver
                momentos de paz en familia."
              </p>
            </div>

            <a href="https://mujerequilibrista.com/cart/48401115611365:1" className="w-full md:w-auto px-8 py-4 text-xl font-bold text-white bg-[#C4704B] rounded-full shadow-lg hover:bg-[#A85A38] hover:scale-105 transition-all duration-300 flex items-center justify-center mx-auto mb-6" data-id="element-149">
              Quiero el Reset Familiar <ArrowRight className="ml-2 h-6 w-6" data-id="element-150" />
            </a>

            <div className="flex items-center justify-center text-[#4A5568] text-sm" data-id="element-151">
              <ShieldCheck className="h-4 w-4 mr-2 text-[#2D6A4F]" data-id="element-152" />
              Pago seguro y encriptado
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}